
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dfoipqpmtfvjghzgteir.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRmb2lwcXBtdGZ2amdoemd0ZWlyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc4MDQwOTIsImV4cCI6MjA4MzM4MDA5Mn0.TujVMlUzPpi3COZDRPYlmVpM1AkQi95cHPDTD_xd9hE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
